<template>
  <div>
    <md-card>
      <md-card-header>
        <div class="md-layout">
          <div class="md-layout-item md-size-90">
            <h4 class="title">Departures</h4>
            <p class="category">
              Listing the Departures for <strong>{{ tour.title }}</strong>
            </p>
          </div>
          <div class="md-layout-item md-size-10 text-right">
            <md-button
              v-if="$allowed('departure.create')"
              class="md-icon-button md-dense md-primary md-round"
              @click.prevent="newDeparture"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top"
                >Add a new Departure<br />to this Adventure</md-tooltip
              >
            </md-button>
          </div>
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout" id="future-departures">
          <div class="md-layout-item md-size-100" v-if="tour.departures">
            <md-table v-model="tour.departures" @md-selected="onSelect">
              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
                md-selectable="single"
              >
                <md-table-cell class="status">
                  <i
                    v-if="item.status.key == 'Confirmed'"
                    class="far fa-calendar-check text-success"
                    ><md-tooltip md-direction="top"
                      >This Departure is Confirmed</md-tooltip
                    ></i
                  >
                  <i v-else class="far fa-calendar-times text-danger"
                    ><md-tooltip md-direction="top"
                      >This Departure is
                      <strong>NOT</strong> Confirmed</md-tooltip
                    ></i
                  >
                </md-table-cell>
                <md-table-cell md-label="Departure Date">{{
                  item.start_date | formatDate
                }}</md-table-cell>
                <md-table-cell md-label="Travellers">{{
                  item.num_passengers
                }}</md-table-cell>
                <md-table-cell class="text-right">
                  <md-button
                    v-if="!item.bookings_count && $allowed('departure.delete')"
                    class="md-just-icon md-simple md-danger"
                    @click.stop="deleteDeparture(item)"
                  >
                    <md-icon>remove_circle</md-icon>
                    <md-tooltip md-direction="top"
                      >Remove this Departure</md-tooltip
                    >
                  </md-button>
                  <template v-if="tour">
                    <md-button
                      :to="{
                        name: 'Departure Profile',
                        params: { departure_id: item.id }
                      }"
                      class="md-success md-just-icon md-simple"
                    >
                      <md-icon>visibility</md-icon>
                      <md-tooltip md-direction="top"
                        >View this Departure</md-tooltip
                      >
                    </md-button>
                  </template>
                </md-table-cell>
              </md-table-row>

              <md-table-empty-state
                md-label="Let's Fly Away..."
                :md-description="`No Future Departures to show.`"
              >
                <md-button class="md-primary md-raised" @click="newDeparture"
                  >Add New Departure</md-button
                >
              </md-table-empty-state>
            </md-table>
          </div>
        </div>

        <tour-tabs-departures-historic
          :tour="tour"
        ></tour-tabs-departures-historic>
      </md-card-content>
    </md-card>

    <md-dialog :md-active.sync="showDepartureDialog">
      <md-dialog-title>Create a New Departure</md-dialog-title>

      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(createDeparture)">
          <departure-dates
            v-if="showDepartureDialog"
            v-model="departure"
            :initial-days="tour.default_departure_days"
          />
          <md-dialog-actions>
            <md-button class="md-primary md-dense" @click="cancel"
              >Cancel</md-button
            >
            <md-button
              :disabled="!departure.end_date"
              type="submit"
              class="md-primary md-dense"
              >Create</md-button
            >
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>
<script>
import tourApi from "@/services/api/tour";
import DepartureDates from "@/components/Handi/DepartureDates.vue";
import _filter from "lodash/filter";
import confirm from "@/helpers/deleteConfirm";
import TourTabsDeparturesHistoric from "./TourTabsDeparturesHistoric";

export default {
  props: ["tour"],

  data() {
    return {
      showDepartureDialog: false,
      departure: {
        start_date: null,
        end_date: null
      }
    };
  },

  components: {
    DepartureDates,
    TourTabsDeparturesHistoric
  },

  methods: {
    onSelect(item) {
      this.$router.push({
        name: "Departure Profile",
        params: { departure_id: item.id }
      });
    },

    createDeparture() {
      if (!this.departure.end_date) return;
      tourApi.createDeparture(this.tour, this.departure).then(response => {
        this.$router.push({
          name: "Departure Profile",
          params: {
            tour_id: this.tour.id,
            departure_id: response.data.id
          }
        });
      });
    },

    deleteDeparture(departure) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          tourApi.deleteDeparture(this.tour.id, departure.id).then(response => {
            this.tour.departures = _filter(this.tour.departures, function(dep) {
              return dep.id !== departure.id;
            });

            this.$notify({
              timeout: 2500,
              message: "The Departure has been deleted.",
              icon: "cancel",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });
          });
        }
      });
    },

    newDeparture() {
      this.departure = { start_date: null, end_date: null };
      this.showDepartureDialog = true;
    },
    cancel() {
      this.showDepartureDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.md-empty-state {
  padding: 30px;
}
.status {
  width: 30px;
}
</style>
